module.exports = __webpack_public_path__ + "dimer/static/img/23.20d1596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/23.jpg
// module id = yu04
// module chunks = 0